module.exports = __webpack_public_path__ + "static/media/IMG_5802.96a93a66.JPG";